import React from 'react';
import Home from './pages/Home';
import About from './pages/About';
import { Routes, Route } from 'react-router-dom';
import Services from './pages/Services';
import Portfolio from './pages/Portfolio';
import Blogs from './pages/Blogs';
import Contact from './pages/Contact';
import GetAQuote from './pages/GetAQuote';
import WebsiteDevelopment from './pages/WebsiteDevelopment';
import AppDevelopment from './pages/AppDevelopment';
import EcommerceDevelopment from './pages/EcommerceDevelopment';
import DigitalMarketing from './pages/DigitalMarketing';
import Seo from './pages/Seo';
import GraphicsDesigning from './pages/GraphicsDesigning';



function App() {
  return (

    <div>

      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/services' element={<Services />} />
        <Route path='/portfolio' element={<Portfolio />} />
        <Route path='/blogs' element={<Blogs />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/getaqute' element={<GetAQuote />} />
        <Route path='/websitedevelopment' element={<WebsiteDevelopment />} />
        <Route path='/appdevelopment' element={<AppDevelopment />} />
        <Route path='/ecommercedevelopment' element={<EcommerceDevelopment />} />
        <Route path='/digitalmarketing' element={<DigitalMarketing />} />
        <Route path='/seo' element={<Seo />} />
        <Route path='/graphicsdesigning' element={<GraphicsDesigning />} />

      </Routes>

    </div>

  );
}

export default App;
